import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {
  DocumentControllerService,
  ExcelExportFilterParamsWrapper,
  FilterInformationDTO, HistoricalValueControllerService, HistoricalValuePresentationDTO,
  ProductTypeControllerService,
  ProductTypeDTO
} from '../../../api';
import {HistoricalValuesService} from '../services/historical-values.service';
import {HttpErrorResponse} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {BsLocaleService, defineLocale, deLocale} from 'ngx-bootstrap';
import {saveAs} from 'file-saver';
import {FiltersService} from './filters.service';

defineLocale('de', deLocale);

@Component({
  selector: 'app-historical-values-filters',
  templateUrl: './historical-values-filters.component.html',
  styleUrls: ['./historical-values-filters.component.scss']
})
export class HistoricalValuesFiltersComponent implements OnInit, OnChanges {

  @Input() dataFilters;

  public productYear = 2018;
  public NCG_CAL_PRICE: number;
  public NCG_CAL_PRICE_TREND: number;
  public BASE_CAL_PRICE: number;
  public BASE_CAL_PRICE_TREND: number;

  public currentFilterInformation;

  public productTypes: Array<ProductTypeDTO> = [];
  public selectedProductType: ProductTypeDTO;

  public isFilterCollapsed = true;
  public startDate: Date;
  public endDate: Date;

  public showLoadingIndicator = false;
  public showYearsFilterLoadingIndicator = false;

  constructor(private filtersService: FiltersService,
              private productTypeControllerService: ProductTypeControllerService,
              private historicalValuesService: HistoricalValuesService,
              private historicalValueControllerService: HistoricalValueControllerService,
              private documentControllerService: DocumentControllerService,
              private bsLocaleService: BsLocaleService) {
  }

  ngOnInit(): void {
    this.bsLocaleService.use(environment.GLOBALS.DEFAULT_LOCALE);

    this.startDate = new Date();
    this.endDate = new Date();

    this.initProductTypes();
    this.getPriceTrendForMainProducts();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.dataFilters) {
      if (changes.dataFilters.currentValue) {
        this.currentFilterInformation.years = this.filtersService.initYearsFilters(changes.dataFilters.currentValue);
      }
      this.historicalValuesService.triggerFilterChangeEvent({
        filtersData: this.currentFilterInformation,
        productType: this.selectedProductType
      });
      this.showYearsFilterLoadingIndicator = false;
      this.showLoadingIndicator = false;
    }
  }

  private initProductTypes() {
    const me = this;

    me.productTypeControllerService.getAllProductTypesUsingGET()
      .subscribe(
        (response: Array<ProductTypeDTO>) => {
          me.productTypes = response;
          me.selectedProductType = me.productTypes[0];
          this.onProductTypeChange(me.productTypes[0]);
        }, (error: HttpErrorResponse) => {
          console.log(error);
        }
      );
  }

  public triggerExport() {
    const filterParams: FilterInformationDTO = {};
    filterParams.flavors = this.currentFilterInformation.flavors;
    filterParams.marketHubs = this.currentFilterInformation.marketHubs;
    filterParams.periodDivisions = this.currentFilterInformation.periodDivisions;
    filterParams.years = this.currentFilterInformation.years;

    // const exportParamsWrapper: ExcelExportFilterParamsWrapper = {
    //   dateFrom: moment(this.startDate).format('YYYY-MM-DD').toString(),
    //   dateTo: moment(this.endDate).format('YYYY-MM-DD').toString(),
    //   filterInformationDTO: filterParams,
    //   productType: this.selectedProductType
    // };
    // this.documentControllerService.exportTranchesToExcelDocumentUsingPOST(exportParamsWrapper).subscribe(response => {
    //   saveAs(response, 'Preishistorie_' + this.getTranslatedProductTypeName(exportParamsWrapper.productType.name)
    //     + '_' + moment(exportParamsWrapper.dateFrom).format('DD.MM.YY')
    //     + '_' + moment(exportParamsWrapper.dateTo).format('DD.MM.YY') + '.xls');
    // }, (error: HttpErrorResponse) => {
    //   console.log(error);
    // });
  }

  private getTranslatedProductTypeName(productTypeName: string) {
    switch (productTypeName) {
      case 'gas':
        return 'Gas';
      case 'electricity':
        return 'Strom';
      default:
        return productTypeName;
    }
  }

  public onProductTypeChange(productType: ProductTypeDTO) {
    this.selectedProductType = productType;
    this.currentFilterInformation = this.filtersService.initFiltersForProductType(this.selectedProductType.name);
    this.showLoadingIndicator = true;
    this.historicalValuesService.triggerSearchEvent(this.selectedProductType, this.startDate, this.endDate);
  }

  public onDateChange() {
    this.showYearsFilterLoadingIndicator = true;
    this.historicalValuesService.triggerSearchEvent(this.selectedProductType, this.startDate, this.endDate);
  }

  public onFilterChanges(event, filter) {
    filter.checked = event;
    this.historicalValuesService.triggerFilterChangeEvent({
      filtersData: this.currentFilterInformation,
      productType: this.selectedProductType,
      filterValue: filter
    });
  }

  private getPriceTrendForMainProducts() {
    this.historicalValueControllerService.findLatestHistoricalValuesForProductNameWithOffsetUsingGET('GPL CAL ' + this.productYear, 2)
      .subscribe((response: Array<HistoricalValuePresentationDTO>) => {
        this.NCG_CAL_PRICE = response[1].settlementValue;
        this.NCG_CAL_PRICE_TREND = response[0].settlementValue - response[1].settlementValue;
      }, (error: HttpErrorResponse) => {
        console.log(error);
      });

    this.historicalValueControllerService.findLatestHistoricalValuesForProductNameWithOffsetUsingGET('Base CAL ' + this.productYear, 2)
      .subscribe((response: Array<HistoricalValuePresentationDTO>) => {
        this.BASE_CAL_PRICE = response[1].settlementValue;
        this.BASE_CAL_PRICE_TREND = response[0].settlementValue - response[1].settlementValue;
      }, (error: HttpErrorResponse) => {
        console.log(error);
      });
  }

}
